<style scoped>

  .ui.avatar.image {
    margin-right: 8px;
    height: 24px;
    width: 24px;
  }

</style>

<template>

  <div id="sidebar" class="ui right vertical sidebar large menu">

    <div class="item">
      <img class="ui centered small image" src="/assets/images/logo.png">
    </div>
    <div class="ui simple dropdown item dropdown-menu-item">
      <img class="ui avatar image" src="/assets/images/user.png">
      <div class="text" :class="{ blue: isProfilePage, black: !isProfilePage }">
        {{ $store.state.user.name }} <i class="dropdown icon"></i>
      </div>
      <div class="menu" style="left: 20px !important;">
        <a class="item" @click="navTo('/profile')">
          <span :class="{ 'blue text': isProfilePage }">
            <i class="edit left icon"></i> Perfil
          </span>
        </a>
        <a class="item" @click="navTo('/use-terms')">
          <span :class="{ 'blue text': isUseTermsPage }">
            <i class="info circle left icon"></i> Termos de Uso
          </span>
        </a>
        <div class="divider"></div>
        <a class="item" @click="onLogout()">
          <i class="sign out left icon"></i> Sair
        </a>
      </div>
    </div>
    <a v-if="!$isCustomerOrProspect()" class="item" @click="navTo('/')">
      <span :class="{ 'blue text': isHomePage }">
        <i class="pie chart left icon"></i> Dashboard
      </span>
    </a>
    <div class="ui simple dropdown item dropdown-menu-item">
      <i class="cubes left icon"></i>
      <span :class="{ 'blue text': isProductsPage }">Estoques<i class="dropdown icon"></i></span>
      <div class="menu" style="left: 20px !important;">
        <a class="item" @click="navTo('/products/search')">
          <span :class="{ 'blue text': isProductsSearchPage }">
            <i class="search icon"></i> Consultar
          </span>
        </a>
        <a v-if="!$isProspect()" class="item" @click="navTo('/products/reserves')">
          <span :class="{ 'blue text': isProductsReservesPage }">
            <i class="lock icon"></i> {{ $isCustomer() ? 'Minhas reservas' : 'Reservas' }}
          </span>
        </a>
      </div>
    </div>
    <a v-if="!$isCustomerOrProspect()" class="item" @click="navTo('/quotations')">
      <span :class="{ 'blue text': isQuotationsPage }">
        <i class="file alt left icon"></i> Orçamentos
      </span>
    </a>
    <a v-if="$isCustomer()" class="item" @click="navToCustomerPage()">
      <span :class="{ 'blue text': isCustomersPage }">
        <i class="search left icon"></i> Consultas
      </span>
    </a>
    <a v-if="!$isCustomerOrProspect()" class="item" @click="navTo('/customers')">
      <span :class="{ 'blue text': isCustomersPage }">
        <i class="user left icon"></i> Clientes
      </span>
    </a>    

  </div>

</template>

<script>

  import isPageMixin from "@/mixins/ispage"

  export default {

    mixins: [isPageMixin],

    methods: {

      navTo(route) {

        $("#sidebar").sidebar("hide")

        this.$router.push(route)
      },

      navToCustomerPage() {

        const customer = this.$store.state.user.customer
        let route = `/customers/show/${customer.code}/${customer.unit}`

        this.navTo(route)
      },

      onLogout() {
        this.$emit("onLogout")
      },
    },

  }


</script>
